<script>
  import viewport from '@/js/utils/useViewportAction.js';
  let grow = false;
  export let icon;
  export let text;
</script>

<div
  class="benefit-item"
  class:grow
  use:viewport
  on:enterViewport={() => (grow = true)}
>
  {#if icon}
    <img
      class="benefit-item__icon"
      src={icon.src}
      width="60"
      height="60"
      alt={icon.alt}
    />
  {/if}
  <p class="benefit-item__text text-small">{@html text}</p>
</div>

<style lang="scss">
  @keyframes fade-up {
    0% {
      opacity: 0;
      transform: translateY(30px);
    }

    75% {
      opacity: 0.5;
    }

    100% {
      opacity: 1;
      transform: translateY(0);
    }
  }
  .benefit-item {
    text-align: center;

    &.grow {
      animation: fade-up 1s ease-in-out backwards;
    }

    &__icon {
      margin: 0 auto;
    }
    &__text {
      margin: 1.5rem 0 0;
    }
  }
</style>
